import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { ChevronLeft, ChevronRight, Mail, Users, Building2, Pencil, Check } from 'lucide-react';
import { Input } from '../ui/input';
import { API_URL, MetaProgress, mesLabel, shiftMonth, errMsg, clampMeta } from './com360Shared';

const MetaEditor = ({ userId, value, onSaved }) => {
  const [edit, setEdit] = useState(false);
  const [v, setV] = useState(value);
  useEffect(() => setV(value), [value]);
  const save = async () => {
    try {
      await axios.put(`${API_URL}/users/${userId}/meta`, { meta_mensal: clampMeta(v) });
      toast.success('Meta atualizada'); setEdit(false); onSaved();
    } catch (e) { toast.error(errMsg(e, 'Erro ao guardar meta')); }
  };
  if (!edit) return (
    <button onClick={() => setEdit(true)} className="inline-flex items-center gap-1 text-xs text-[#4DD4E8] hover:text-white" data-testid="com360-meta-edit">
      <Pencil className="w-3 h-3" />{value ? 'Alterar meta mensal' : 'Definir meta mensal'}
    </button>
  );
  return (
    <span className="inline-flex items-center gap-1">
      <Input type="number" min={0} max={1000} value={v} onChange={(e) => setV(e.target.value)} className="h-7 w-20 text-slate-900" data-testid="com360-meta-input" />
      <button onClick={save} className="w-7 h-7 rounded-md bg-[#4DD4E8] text-[#2D3E6F] flex items-center justify-center" data-testid="com360-meta-save"><Check className="w-4 h-4" /></button>
    </span>
  );
};

export const ComercialHeader = ({ c, meta, month, setMonth, canEdit, onSaved }) => (
  <div className="rounded-2xl bg-[#2D3E6F] text-white p-6 grid gap-6 lg:grid-cols-[1fr_minmax(320px,440px)]" data-testid="com360-header">
    <div className="space-y-2 min-w-0">
      <div className="text-xs uppercase tracking-[0.2em] text-[#4DD4E8]">Página do Comercial</div>
      <h1 className="text-3xl sm:text-4xl font-bold font-[Outfit] break-words" data-testid="com360-name">{c.name}</h1>
      <div className="flex flex-wrap gap-x-5 gap-y-1 text-sm text-white/85">
        <span className="capitalize">{(c.role || '').replace('_', ' ')}</span>
        {c.email && <span className="inline-flex items-center gap-1"><Mail className="w-3.5 h-3.5" />{c.email}</span>}
        {c.partner_name && <span className="inline-flex items-center gap-1"><Building2 className="w-3.5 h-3.5" />{c.partner_name}</span>}
        {c.team_leader_name && <span className="inline-flex items-center gap-1"><Users className="w-3.5 h-3.5" />Chefe: {c.team_leader_name}</span>}
        {!c.active && <span className="px-2 rounded-full bg-rose-600 text-xs font-bold">Inativo</span>}
      </div>
    </div>
    <div className="rounded-xl bg-white/10 p-4 space-y-3">
      <div className="flex items-center justify-between">
        <button onClick={() => setMonth(shiftMonth(month, -1))} className="p-1 rounded hover:bg-white/10" data-testid="com360-month-prev"><ChevronLeft className="w-4 h-4" /></button>
        <span className="text-sm font-semibold" data-testid="com360-month">Meta de {mesLabel(month)}</span>
        <button onClick={() => setMonth(shiftMonth(month, 1))} className="p-1 rounded hover:bg-white/10" data-testid="com360-month-next"><ChevronRight className="w-4 h-4" /></button>
      </div>
      <MetaProgress meta={meta.meta} feitos={meta.feitos} size="lg" testId="com360-meta" />
      <div className="flex items-center justify-between text-xs text-white/75">
        <span>{meta.meta ? (meta.faltam ? `Faltam ${meta.faltam}` : 'Meta atingida!') : ''}{meta.anulados ? ` · ${meta.anulados} anulado(s) não contam` : ''}</span>
        {canEdit && <MetaEditor userId={c.id} value={c.meta_mensal} onSaved={onSaved} />}
      </div>
    </div>
  </div>
);
